import { PublicClientApplication, type Configuration } from '@azure/msal-browser';
import { env } from '@/env';

const msalConfig: Configuration = {
  auth: {
    clientId: env.VITE_AUTH_CLIENT_ID || '00000000-0000-0000-0000-000000000000',
    authority: env.VITE_AUTH_TENANT_ID
      ? `https://login.microsoftonline.com/${env.VITE_AUTH_TENANT_ID}`
      : 'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

/**
 * msal-browser v5 requires explicit `initialize()` before any other call.
 * `main.tsx` awaits this once before mounting the React tree.
 */
let initPromise: Promise<void> | null = null;
export function ensureMsalInitialized(): Promise<void> {
  if (!initPromise) {
    initPromise = msalInstance.initialize();
  }
  return initPromise;
}

/**
 * Scope required to call the V2 API. Set via `VITE_AUTH_API_SCOPE` —
 * typically `api://<v2-client-id>/access_as_user`. When unset (local dev /
 * non-deployed env), we fall back to OpenID scopes only, which produces a
 * token without the V2 audience — useful for the `AUTH_ENABLED=false`
 * dev-passthrough path on the backend.
 */
export const apiLoginRequest = {
  scopes: env.VITE_AUTH_API_SCOPE
    ? [env.VITE_AUTH_API_SCOPE]
    : ['openid', 'profile', 'email'],
};
